import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import {
  buildTexasHoldemRoomRoute,
  buildTexasHoldemSettlementRoute
} from '../games/routes';

function LegacyTexasHoldemRedirect({ destination = 'room' }) {
  const { roomCode = '' } = useParams();
  const location = useLocation();
  const to = destination === 'settlement'
    ? buildTexasHoldemSettlementRoute(roomCode)
    : buildTexasHoldemRoomRoute(roomCode);

  return <Navigate replace state={location.state} to={to} />;
}

export default LegacyTexasHoldemRedirect;
